/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import ReactTable from 'react-table'
import createTable from 'react-table-hoc-fixed-columns'
// import "react-table/react-table.css";

import CSVExportModal from './CSVExportModal'
import profile_avatar from '../../assets/images/mock/default-profile-icon.png'

const ReactTableFixedColumns = createTable(ReactTable)

class StudentStatsTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      dataLoader: false,
      data: [],
    }
  }

  getHeaders = () => {
    const { t } = this.props
    return [
      { label: t('common.field.lastName'), key: 'lastname' },
      { label: t('common.field.firstName'), key: 'firstname' },
      { label: t('reports.common.pointsEarned'), key: 'pointsearned' },
      { label: t('reports.common.totalActivities'), key: 'totalactivities' },
      { label: t('reports.common.totalPractices'), key: 'totalpractices' },
      {
        label: t('reports.common.totalSocialActions'),
        key: 'totalsocialactions',
      },
      { label: t('reports.common.goalsCompleted'), key: 'goalscompleted' },
      {
        label: t('reports.studentStatsTable.op36LevelsCompleted'),
        key: 'op36rankscompleted',
      },
      { label: t('reports.common.roundsPlayed'), key: 'roundsplayed' },
      {
        label: t('reports.studentStatsTable.nineHoleRoundsPlayed'),
        key: 'nineholeroundsplayed',
      },
      {
        label: t('reports.studentStatsTable.eighteenHoleRoundsPlayed'),
        key: 'eighteenholeroundsplayed',
      },
    ]
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    })
  }

  createData = () => {
    const { data } = this.props
    const tempData = []
    this.setState({ dataLoader: true })
    if (data.length > 0) {
      data.map(info => {
        const lastname = info.student.last_name
        const firstname = info.student.first_name
        const pointsearned = info.report.stats.points
        const totalactivities = info.report.stats.total_activities
        const totalpractices = info.report.stats.total_train_activities
        const totalsocialactions = info.report.stats.total_social_activities
        const goalscompleted = info.report.stats.total_goal_activities
        const op36rankscompleted = info.report.stats.ranks_completed
        const roundsplayed = info.report.stats.total_play_activities
        const nineholeroundsplayed = info.report.stats.nine_hole_rounds
        const eighteenholeroundsplayed = info.report.stats.eighteen_hole_rounds

        tempData.push({
          lastname,
          firstname,
          pointsearned,
          totalactivities,
          totalpractices,
          totalsocialactions,
          goalscompleted,
          op36rankscompleted,
          roundsplayed,
          nineholeroundsplayed,
          eighteenholeroundsplayed,
        })
      })
    }

    this.setState({
      showModal: !this.state.showModal,
      data: tempData,
    })
  }

  renderUserAvatarCell = props => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      key={props.value ? props.value.id : null}
      onClick={() =>
        this.props.toProfile(props.value ? props.value.id : null)
      }
    >
      <div className='small-round-image-wrapper'>
        {props.value ? (
          <img
            className='round-image'
            src={
              props.value.avatar
                ? props.value.avatar.file_url
                : profile_avatar
            }
            alt={
              props.value
                ? `${props.value.first_name} ${props.value.last_name}`
                : ''
            }
          />
        ) : null}
      </div>
    </div>
  )
  renderTableBGColor = type => {
    switch (type) {
      case 'play':
        return '#00ddb0'
      case 'train':
        return '#00aee5'
      case 'social':
        return '#6775e5'
      case 'goal':
        return '#f48e00'
      case 'rank':
        return '#f48e00'
      case 'main':
        return '#2b3843'
      default:
        return ''
    }
  }
  renderTableCell = (props, type) => (
    <div
      className='number'
      style={{
        backgroundColor: this.renderTableBGColor(type),
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: !type ? '#2b3843' : 'white' }}>{props.value}</div>
    </div>
  )
  renderMainTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '#2b3843',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: 'white' }}>{props.value}</div>
    </div>
  )
  lastActionSort = (a, b, _desc) => {
    a = a === null || a === undefined ? '' : a.days_since
    b = b === null || b === undefined ? '' : b.days_since

    if (a > b) {
      return 1
    }
    if (a < b) {
      return -1
    }
    return 0
  }
  renderTable = () => {
    const { t, loader, data } = this.props
    const columns = [
      {
        Header: '',
        accessor: 'student',
        Cell: props => this.renderUserAvatarCell(props),
        sortable: false,
        fixed: true,
      },
      {
        Header: t('common.field.firstName'),
        accessor: 'student.first_name',
        fixed: true,
      },
      {
        Header: t('common.field.lastName'),
        accessor: 'student.last_name',
        fixed: true,
      },
      {
        Header: t('reports.common.pointsEarned'),
        accessor: 'report.stats.points',
        Cell: props => this.renderTableCell(props, 'main'),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.totalActivities'),
        accessor: 'report.stats.total_activities',
        Cell: props => this.renderTableCell(props, 'main'),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.totalPractices'),
        accessor: 'report.stats.total_train_activities',
        Cell: props => this.renderTableCell(props, 'train'),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.totalSocialActions'),
        accessor: 'report.stats.total_social_activities',
        Cell: props => this.renderTableCell(props, 'social'),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.goalsCompleted'),
        accessor: 'report.stats.total_goal_activities',
        Cell: props => this.renderTableCell(props, 'goal'),
        style: { padding: 0 },
      },
      {
        Header: t('reports.studentStatsTable.op36LevelsCompleted'),
        accessor: 'report.stats.ranks_completed',
        Cell: props => this.renderTableCell(props, 'rank'),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.roundsPlayed'),
        accessor: 'report.stats.total_play_activities',
        Cell: props => this.renderTableCell(props, 'play'),
        style: { padding: 0 },
      },
      {
        Header: t('reports.studentStatsTable.nineHoleRoundsPlayed'),
        accessor: 'report.stats.nine_hole_rounds',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.studentStatsTable.eighteenHoleRoundsPlayed'),
        accessor: 'report.stats.eighteen_hole_rounds',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
    ]

    return (
      <div className='container my-5 animated fadeIn'>
        <div className='row mb-5 d-flex align-items-center'>
          <div className='col-md-4'>
            <h2>{this.props.title}</h2>
          </div>
          <div className='col-md-4 d-flex align-items-center'>
            <button
              className='btn btn-primary mr-2 refresh-button'
              onClick={this.props.resetProgramSearch}
            >
              <i className='fa fa-undo' aria-hidden='true' />
            </button>
            <select
              onChange={this.props.handleProgramSelected}
              value={this.props.programSelected}
              name='program'
              className='form-control'
            >
              <option value={-1} disabled>
                {this.props.programLoader
                  ? t('reports.common.loadingClasses')
                  : t('reports.studentStatsTable.selectClassOptional')}
              </option>
              {this.props.renderPrograms()}
            </select>
          </div>
          <div className='col-md-4'>
            <button
              className='btn btn-sm btn-block'
              onClick={() => this.props.goBack()}
            >
              <i
                className='fa fa-arrow-left text-white mr-1'
                aria-hidden='true'
              />{' '}
              {t('reports.common.viewAnotherReport')}
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <ReactTableFixedColumns
              data={!loader ? data : []}
              columns={columns}
              defaultPageSize={10}
              loading={this.props.loader}
              previousText={t('reports.common.pagination.previous')}
              nextText={t('reports.common.pagination.next')}
              pageText={t('reports.common.pagination.page')}
              ofText={t('reports.common.pagination.of')}
              rowsText={t('reports.common.pagination.rows')}
              loadingText={t('reports.common.loadingReport')}
              noDataText={
                this.props.loader ? '' : t('reports.common.noDataFound')
              }
            />
          </div>
        </div>
        <button onClick={this.createData} className='mt-3 btn btn-success'>
          {t('reports.common.exportAsCsv')}
        </button>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.renderTable()}
        <CSVExportModal
          headers={this.getHeaders()}
          data={this.state.data}
          showModal={this.state.showModal}
          toggleModal={this.toggleModal}
          reportType={this.props.t(
            'reports.studentStatsTable.reportType'
          )}
          filename={'golfer-activity-summary.csv'}
        />
      </div>
    )
  }
}

export default withTranslation()(StudentStatsTable)
